import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 4a1 1 0 0 0 0 2h9.586L4.293 18.293a1 1 0 1 0 1.414 1.414L18 7.414V17a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }